const getResponse = () => {
    return null;
}

const reset = () => {
    return null;
}

export default {
    getResponse,
    reset,
}